import { CanAccess } from '@modules/common/components/CanAccess';
import { UnifiedFieldIcon } from '@modules/common/components/UnifiedFieldIcon';
import {
  NAV_PATHS,
  UNIFIED_FIELD_HELP_CENTER_DOC,
} from '@modules/common/constants';
import { trackIntegrationPageManageMetadataEvent } from '@modules/integrationsV2/utils';
import { InfoOutlined } from '@mui/icons-material';
import {
  Button,
  Link as MuiLink,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { Link } from 'react-router-dom';

const unifiedFieldDescription = (
  <Typography variant="inherit">
    Unified Fields let you merge similar metadata from different feedback
    sources into one field. For example, "Playstore Score" and "Appstore Rating"
    can become a single "App Rating."{' '}
    <MuiLink href={UNIFIED_FIELD_HELP_CENTER_DOC} target="_blank">
      Learn more
    </MuiLink>
  </Typography>
);

export const ManageUnifiedFieldButton = () => {
  return (
    <Stack direction="row" alignItems="center">
      <CanAccess
        resource={PermissionResource.Integration}
        operation={PermissionOperation.Write}
      >
        <Button
          component={Link}
          to={`/${NAV_PATHS.MANAGE_UNIFIED_FIELDS}`}
          variant="text"
          size="large"
          startIcon={<UnifiedFieldIcon />}
          sx={{
            zIndex: 1,
            color: 'info.main',
          }}
          onClick={() => {
            trackIntegrationPageManageMetadataEvent({
              eventName:
                'Integrations Page - Manage Unified Field Button clicked',
            });
          }}
        >
          Manage unified fields
        </Button>
      </CanAccess>

      <Tooltip title={unifiedFieldDescription} arrow>
        <InfoOutlined sx={{ color: 'text.secondary' }} />
      </Tooltip>
    </Stack>
  );
};
